import React, { Component } from 'react';
import { View, Easing } from 'react-native';
import Modal from 'react-native-modal';
import Application from 'base/navigator/Application';
import Toast from 'utils/Toast';
import { ErrorBoundary } from 'base/navigator/ErrorBoundary';
import YPStatSend from 'utils/YPStatSend';
import PigeonMaker from 'bsl/utils/PigeonMaker';
import { AppContext } from 'base/navigator/AppContext';
import Uri from 'base/navigator/Uri';
import ToastContainer from 'tmpl/common/ToastContainer';
import ld from 'lodash';
import Url from 'url';
import { getDefaultNavigatorName, getExtraStatConstants } from './tools';
import routes from '../../mishop/routes/index.json';

const AuthUtil = require('common/AuthUtil');

export default function asyncComponent(importComponent, name) {
  class AsyncComponent extends Component {
    constructor(props) {
      super(props);
      this.route = Uri.getDefaultRoute({
        uri: location.href,
        routes: routes,
      });
      this.app = new Application();
      this.state = {
        component: null,
        modalVisible: false,
        showMessage: '',
      };
      this.modalExtraProps = null;
      // 设置全局context的值， 值不可发生二次更改
      this.compRef = null;
      this.defaultNavigatorName = `$${name}$`;
      let params = {};
      try {
        params = Url.parse(location.href, true).query;
      } catch (error) {
        return null;
      }
      this.YPStatSend = new YPStatSend(params, this.defaultNavigatorName);
      // 获取默认b位
      this.defaultNavigatorName = getDefaultNavigatorName(this.route.component, this.route); // (this.route.component && `${this.route.component}`) || 'no_page';
      const extraStatConstants = getExtraStatConstants(this.route.component, this.route);
      this.YPStatSend = new YPStatSend(this.route.params, this.defaultNavigatorName, {
        extraConstants: {
          ...extraStatConstants,
          spmref: ld.get(this.route, 'params.action.spm_stat.spm_code') || ld.get(this.route, 'params.spmref') || '',
        },
        uri: location.href,
      });
      const { spmref = '', scm = '', last_scmv2 = '', scmv2_num = 0 } = params;
      const pigeonMaker = new PigeonMaker(spmref, scm, last_scmv2, scmv2_num);
      const _this = this;

      this.contextValue = {
        instance: 0,
        get navigatorName() {
          return (_this.compRef && _this.compRef.navigatorName) || `$_none_$`;
        },
        openUrl: this.openUrl,
        onBackPress: this.onBackPress,
        YPStatSend: this.YPStatSend,
        pigeonMaker: pigeonMaker,
        app: this.app,
      };
    }

    async componentDidMount() {
      const isEmptyProduct = this.defaultNavigatorName === 'product';
      if (!isEmptyProduct) {
        this.YPStatSend.view(this.defaultNavigatorName, this.props.uri, {
          // pageName: this.contextValue.navigatorName,
          scmref: this.YPStatSend.getLastScmV2(),
          scmref_step: this.YPStatSend.getLastScmV2Step(),
          spmref: ld.get(this.route, 'params.action.spm_stat.spm_code') || ld.get(this.route, 'params.spmref') || '',
          uriref: '',
        });
      }
      this.app.init();
      this.app.setPopModal(this.showPopModal);
      Toast.setShowFunction(this.showMessageToast.bind(this));
      try {
        await AuthUtil.updateAuth();
      } catch (error) {
        console.log('asyncloader', error);
      }
      // const { default: component } = await importComponent();
      const defaultComponent = await importComponent();
      const component = defaultComponent.default ? defaultComponent.default : defaultComponent;
      this.setState({
        component: component,
      });
    }

    componentWillUnmount() {
      this.app.uninit();
    }

    showPopModal = (visible, render, extraConf) => {
      this.modalExtraProps = extraConf;
      this.setState({
        modalVisible: visible,
        modalShow: render,
      });
    };

    closeModal = (extraConf) => {
      this.showPopModal(false, null, extraConf);

      // this.setState({
      //   modalVisible: false,
      //   popModalRender: null,
      // });
      // if (this.props.app.closeModalBack) {
      //   this.props.app.closeModalBack();
      // }
    };

    showMessageToast(message) {
      if (this.state.showMessage == '') {
        this.setState({
          showMessage: message,
        });
        this.timer = setTimeout(() => {
          this.setState({
            showMessage: '',
          });
        }, 2500);
      } else {
        this.timer && clearTimeout(this.timer);
        this.setState({
          showMessage: message,
        });
        this.timer = setTimeout(() => {
          this.setState({
            showMessage: '',
          });
        }, 2500);
      }
    }

    setPageRef = (ref) => {
      this.compRef = ref;
    };

    openUrl = (url) => {
      Uri.openUri(this.props.history, url);
    };

    onBackPress = () => {
      Uri.back();
    };

    parseQueryString(url) {
      const result = this.urlParse(url);
      return result.query;
    }

    urlParse(url) {
      let arr;
      const res = {};
      // #符号之后的值称为hash，都不会加到request请求中去
      const hashUrl = url.split('#');
      url = hashUrl[0];
      const hash = hashUrl[1];
      // 获取queryString 第一个？号后面的全是查询字符串
      arr = url.split('?');
      const urlPath = arr.shift();
      const queryStr = arr.join('?');
      // 查询字符串为空直接返回 避免出现这样的返回值{"":""}
      if (queryStr.trim().length !== 0) {
        // 获取参数
        arr = queryStr.split('&');
        for (let i = 0; i < arr.length; i++) {
          const itemArr = arr[i].split('=');
          // 第一个=号之前的是name 后面的全是值
          const name = itemArr.shift();
          const value = itemArr.join('=');
          res[name] = decodeURIComponent(value);
        }
      }
      return {
        url: urlPath,
        query: res,
        hash: hash || '',
      };
    }

    render() {
      const C = this.state.component;
      const history = this.props.history;
      const params = this.parseQueryString(this.props.location.search);
      const props = {
        ...this.props,
        navigator: { history: history, componentName: name },
        ...params,
        app: this.app,
        ref: 'rootPage',
      };
      const { modalShow } = this.state;

      // width: CommonStyles.ViewWidth, height: CommonStyles.ViewHeight
      return (
        <AppContext.Provider value={this.contextValue}>
          <ErrorBoundary uri={location.href} navigator={props.navigator} instance={this.props.instance}>
            <View style={{ flex: 1 }}>
              {C ? (
                <C
                  {...props}
                  componentName={name}
                  navigatorName={this.defaultNavigatorName}
                  ref={this.setPageRef}
                  openUrl={this.openUrl}
                  onBackPress={this.onBackPress}
                  YPStatSend={this.YPStatSend}
                />
              ) : null}
              {this.state.showMessage !== '' ? <ToastContainer message={this.state.showMessage} /> : null}
            </View>
            <Modal
              style={{ margin: 0 }}
              transparent={true}
              coverScreen={true}
              useNativeDriver={true}
              onBackdropPress={this.closeModal}
              isVisible={this.state.modalVisible}
              onBackButtonPress={this.closeModal}
              easing={Easing.ease}
              {...this.extraConf}
            >
              {modalShow && modalShow()}
            </Modal>
          </ErrorBoundary>
        </AppContext.Provider>
      );
    }
  }

  return AsyncComponent;
}
